/**
 * @module playerManager
 * @private
 */

import { sessionId, localUserId } from "../../store";

let youboraPlugin = null;
let libLoaded = false;
const errorCodesIgnore = ['1400','3011','9000','3017','2007','1023','1301','3024','1202','3000','3006','1016','3002','2008','2009','3016','1204','2006','3023','1208','1200','1000','1103','1012','2003','3032','errorcode']
function getQuality(has4K) {
  return has4K ? "4K" : "HD";
}

async function getYouboraOptions(config) {
  return {
    username: localStorage.getItem('globalUserId') ,
    "content.transactionCode": config.id,
    "content.title": config.playbackAnalytics.title,
    "content.isLive": config.isLive || false,
    "content.duration": config.playbackAnalytics.duration,
    "content.resource": config.manifest,
    "content.id": config.id,
    'content.customDimension.1': config.addonContent,
    "content.metadata": {
      content_metadata: {
        title: config.playbackAnalytics.title,
        genre: config.playbackAnalytics.genre,
        language: this.lang,
        parental: this.parentalLevel,
        duration: config.playbackAnalytics.duration,
        mediaGuid: config.playbackAnalytics.mediaGuid,
        app_version: this.publicVersion,
        app_build_version: this.appVersion,
        sdk_build_version: this.version,
        sessionId: sessionId.get(),
        season: config.playbackAnalytics.season,
        episode: config.playbackAnalytics.episode,
        play_from: config.playbackAnalytics.playFrom,
        resume: !!config.playbackAnalytics.resume ? "yes" : "no"
      },
      device: {
        manufacturer: this.device.getManufacturer(),
        type: this.device.getType(),
        year: await this.device.getYear(),
        firmware: await this.device.getFirmwareVersion(),
        smartHub: await this.device.getServerVersion(),
        duid: await this.device.getId(),
        modelName: await this.device.getRealModel()
      },
      filename: config.manifest,
      content_type: config.videoType,
      quality: getQuality(config.playbackAnalytics.is4KEnabled),
    "freeToAir": config.freeToAir
    }
  };
}

const adapters = {
  tizen: () => new youbora.adapters.SamsungAvplay("av-player"),  //Tizen 2015 and 2016
  webmaf: () => new youbora.adapters.PsWebmaf(),
  bitmovin: player => new youbora.adapters.Bitmovin8(player) // Hisense ,Tizen 2017 and above and LG
};
export default {
  /**
   *
   * @param {String} adapter name of the youbora adapter
   */
  initialize(adapter, player) {
    youboraPlugin === null &&
      (youboraPlugin = new youbora.Plugin({
        accountCode: this.playbackAnalytics.accountCode,
        enabled: this.playbackAnalytics.enableAnalytics,
        httpSecure: this.playbackAnalytics.httpSecure,
        'errors.ignore': errorCodesIgnore

      })) &&
      youboraPlugin.setAdapter(adapters[adapter](player));
  },

  resetAdapter(adapter, player) {
    try {
      //youboraPlugin.disable();
      youboraPlugin.removeAdapter(adapters[adapter](player));
    } catch (e) {}
    try {
      //youboraPlugin.enable();
      youboraPlugin.setAdapter(adapters[adapter](player));
    } catch (e) {}
  },

  /**
   * Loads the url of youbora lib
   * @param {String} src Lib url
   */
  loadYouboraLib(src, onload) {
    if (!libLoaded) {
      const s = document.createElement("script");
      s.setAttribute("src", src);
      s.addEventListener("load", onload);
      document.body.appendChild(s);
      libLoaded = true;
      return true;
    } else {
      return false;
    }
  },

  /**
   * Sets options for current content
   * @param {Object} options
   */
  async setOptions(options) {
    youboraPlugin && youboraPlugin.setOptions(await getYouboraOptions.call(this, options));
  },

  /**
   * Sends a youbora event
   * @param {Function} eventCallback Youbora callback
   * @param {Number} errorCode Error code
   * @param {String} errorMessage Error message
   */
  sendEvent(eventCallback, errorCode = null, errorMessage = null) {
    youboraPlugin &&
      youboraPlugin.getAdapter() &&
      youboraPlugin.getAdapter()[eventCallback] &&
      youboraPlugin.getAdapter()[eventCallback](errorCode, errorMessage);
  },

  /**
   * Returns youbora plugin instance
   */
  getYouboraPlugin() {
    return youboraPlugin;
  },
  /* Youbora events */
  events: {
    init: "fireInit",
    start: "fireStart",
    pause: "firePause",
    resume: "fireResume",
    stop: "fireStop",
    seekBegin: "fireSeekBegin",
    seekEnd: "fireSeekEnd",
    bufferBegin: "fireBufferBegin",
    bufferEnd: "fireBufferEnd",
    join: "fireJoin",
    error: "fireError",
    endedHandler: "endedHandler"
  }
};
